import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Item } from '../../../core/models/share/item';
import { PaymentMethod } from '../../../core/models/payment/payment-method';
import { SettingService } from '../../../core/services/api/setting.service';
import { ErrorService } from '../../../core/services/error.service';

// INC-289 Phase 1: bank fields (bankId, accountNumber, accountHolder)
// extracted verbatim from payment-methods.component.ts's buildForm() so the
// standalone settings page and the Phase-2 review-attest edit sheet share ONE
// copy of the validators and error messages. The page's own showForm /
// read-only-summary toggle and the actual save call stay on the page.
@Component({
  standalone: false,
  selector: 'app-bank-section-form',
  templateUrl: './bank-section-form.component.html',
  styleUrls: ['./bank-section-form.component.scss'],
})
export class BankSectionFormComponent implements OnInit, OnChanges {
  @Input() paymentMethod: PaymentMethod;
  @Input() showFormError = false;

  form: UntypedFormGroup;
  bankList: Item[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private settingService: SettingService,
    private errorService: ErrorService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.getBankList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Guarded on `this.form` since the very first change (the one Angular
    // fires before ngOnInit) arrives before buildForm() has run; ngOnInit
    // does that initial seed instead.
    if (changes.paymentMethod && this.paymentMethod && this.form) {
      this.form.patchValue(this.paymentMethod);
    }
  }

  buildForm(): void {
    this.form = this.formBuilder.group({
      'bankId': ['', Validators.required],
      'accountNumber': [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(/^[0-9]*$/),
          Validators.maxLength(31),
        ]),
      ],
      'accountHolder': ['', Validators.required],
    });

    if (this.paymentMethod) {
      this.form.patchValue(this.paymentMethod);
    }
  }

  getBankList(): void {
    this.settingService.getBankList().subscribe(
      (data) => {
        this.bankList = data;
        this.bankList = this.bankList.filter((bank) => bank.id != 0);
      },
      (err) => {
        this.errorService.showError(err);
      },
    );
  }
}
